var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showIcon)?_c('span',_vm._b({staticClass:"unread-header"},'span',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.displayUnreadCount)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }